<script lang="ts" setup>
import { reactive } from 'vue';
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import { useI18n } from 'vue-i18n';

import AlternateMarquee from '@@home/components/AlternateMarquee.vue';

const { t } = useI18n();
const welfareTab = reactive([
  {
    title: t('cooperation.welfareDonate.welfareTab.title1'),
  },
  {
    title: t('cooperation.welfareDonate.welfareTab.title2'),
  }
])

const specialTabpanel = {
  headerTitle: t('cooperation.welfareDonate.welfareTab.title2'),
  list: [
    t('cooperation.welfareDonate.specialTabpanel.list1'),
    t('cooperation.welfareDonate.specialTabpanel.list2'),
  ],
  contentTitle: t('cooperation.welfareDonate.welfareTab.contentTitle'),
  contentList: [
    {
      title: t('cooperation.welfareDonate.contentList.title1'),
      desc: t('cooperation.welfareDonate.contentList.desc1'),
    },
    {
      title: t('cooperation.welfareDonate.contentList.title2'),
      desc: t('cooperation.welfareDonate.contentList.desc2'),
    },
    {
      title: t('cooperation.welfareDonate.contentList.title3'),
      desc: t('cooperation.welfareDonate.contentList.desc3'),
    },
    {
      title: t('cooperation.welfareDonate.contentList.title4'),
      desc: t('cooperation.welfareDonate.contentList.desc4'),
    },
    {
      title: t('cooperation.welfareDonate.contentList.title5'),
      desc: t('cooperation.welfareDonate.contentList.desc5'),
    },
  ]
}

const unSpecialTabpanel = {
  headerTitle: t('cooperation.unSpecialPanel.title'),
  headerContent: t('cooperation.unSpecialPanel.content'),
  contentList: [
    {
      title: t('cooperation.unSpecialPanel.extraordinaryTitle'),
      desc: t('cooperation.unSpecialPanel.extraordinaryRule'),
    },
    {
      title: t('cooperation.unSpecialPanel.platinumTitle'),
      desc: t('cooperation.unSpecialPanel.platinumRule'),
    },
    {
      title: t('cooperation.unSpecialPanel.goldTitle'),
      desc: t('cooperation.unSpecialPanel.goldRule'),
    },
    {
      title: t('cooperation.unSpecialPanel.silverTitle'),
      desc: t('cooperation.unSpecialPanel.silverRule'),
    },
  ]
}
</script>

<template>
  <section class="page-cooperation-welfare">
    <h3>{{ $t('cooperation.welfareDonate.title') }}</h3>
    <TabGroup>
      <TabList class="tablist relative flex" v-slot="{ selectedIndex }">
        <div class="absolute underline" :style="{ left: `${(selectedIndex * 680)}px` }"></div>
        <Tab
          v-for="item in welfareTab"
          :key="item.title"
          as="template"
          v-slot="{ selected }"
        >
          <div
            :class="[
              'tablist-btn',
              selected
                ? 'selected'
                : ''
            ]"
          >
            {{ item.title }}
          </div>
        </Tab>
      </TabList>

      <TabPanels class="tabpannels">
        <TabPanel class="tabpanel">
          <div class="tabpanel-card relative w-full flex items-center justify-center">
            <img src="@@home/assets/cooperation/unspecial-bg.png" class="absolute left-0 top-0 h-full -z-1" alt="">
            <div class="tabpanel-card-content mx-auto flex items-start justify-between">
              <div class="content-detail text-white">
                <h4 class="content-title mb-0 mt-0 text-white">{{ unSpecialTabpanel.headerTitle }}</h4>
                <span class="mt-32px block h-192px w-330px overflow-x-auto text-16px font-normal leading-24px">
                  {{ unSpecialTabpanel.headerContent }}
                </span>
              </div>
              <ul class="unspecial-container relative m-0 box-border h-full w-998px flex flex-wrap list-none rounded-[4px] p-0 py-44px after:absolute after:left-1/2 after:top-44px after:h-192px after:w-2px after:content-empty after:-translate-x-1/2 before:absolute before:left-56px before:top-1/2 before:h-2px before:w-886px before:content-empty before:-translate-y-1/2">
                <li v-for="(item, index) in unSpecialTabpanel.contentList" :key="index" class="box-border h-1/2 w-1/2 px-56px" :class="{ 'mt-24px': index > 1 }">
                  <div class="truncate text-[24px] font-medium leading-36px text-#1180FF">{{ item.title }}</div>
                  <AlternateMarquee class="mt-8px h-24px text-[16px] font-medium leading-[24px] text-#2D2D2D">{{ item.desc }}</AlternateMarquee>
                </li>
              </ul>
            </div>
          </div>
        </TabPanel>

        <TabPanel class="tabpanel">
          <div class="tabpanel-card relative w-full flex items-center justify-center">
            <img src="@@home/assets/cooperation/special-donate.png" class="absolute left-0 top-0 h-full -z-1" alt="">
            <div class="tabpanel-card-content mx-auto flex items-start justify-between">
              <div class="content-detail text-white">
                <h4 class="content-title mb-[8px] mt-0 text-white">{{ specialTabpanel.headerTitle }}</h4>
                <div class="mt-24px h-205px overflow-x-auto">
                  <span v-for="(item, index) in specialTabpanel.list" :key="index" class="content-desc block">{{ item }}</span>
                </div>
              </div>
              <div class="content-card box-border h-full rounded-[4px] bg-white">
                <h5 class="mt-0">{{ specialTabpanel.contentTitle }}</h5>
                <img src="@@home/assets/cooperation/welfare-steps.png" alt="">
                <ul class="m-0 flex list-none items-start justify-start p-0">
                  <li v-for="(item, index) in specialTabpanel.contentList" :key="index" class="content-card-list flex shrink-0 flex-col justify-start" :class="[index == 1 ? 'w-200px' : 'w-144px']">
                    <span class="mb-4px inline-block w-full text-[16px] font-medium">{{ item.title }}</span>
                    <span class="inline-block w-full text-[14px] font-normal leading-[22px]">{{ item.desc }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </TabPanel>
      </TabPanels>
    </TabGroup>
  </section>
</template>

<style lang="scss" scoped>
.page-cooperation-welfare {
  width: 100%;
  padding: calc(48px + 32px) 0 48px;  // 此处 calc 会走 scss 编译，这样写比较直观：标准间距加上导航栏吃进去的一部分，后续标准间距也方便改成全局 css 变量
  background: rgba(45, 45, 45, 0.02);

  h3 {
    height: 48px;
    margin-top: 0;
    margin-bottom: 16px;
    color: #2d2d2d;
    font-weight: 500;
    font-size: 32px;
    line-height: 48px;
    text-align: center;
  }

  .tablist {
    justify-content: center;
    width: 1360px;
    height: 68px;
    margin: 0 auto;

    .underline {
      bottom: 0;
      width: 50%;
      height: 1px;
      background: #1180ff;
      transition: left .3s linear;
    }

    &-btn {
      width: 50%;
      height: 68px;
      color: #2d2d2d;
      font-weight: 400;
      font-size: 24px;
      line-height: 68px;
      text-align: center;
      cursor: pointer;

      &:focus-visible {
        outline: unset;
      }

      &.selected {
        color: #1180ff;
      }
    }
  }

  .tabpannels {
    padding-top: 32px;

    .tabpanel {
      width: 100%;
    }

    .tabpanel-card {
      height: 370px;

      &-bg {
        width: 1200px;
      }

      &-content {
        width: 1360px;
        height: 274px;

        .content-detail {
          width: 330px;
        }

        .content-title {
          height: 48px;
          font-weight: 500;
          font-size: 32px;
          line-height: 48px;
        }

        .content-desc {
          font-size: 16px;
          line-height: 24px;

          + .content-desc {
            margin-top: 24px;
          }
        }

        .content-card {
          width: 998px;
          padding: 32px 48px;
          box-shadow: 0 0 60px 0 rgba(0, 37, 79, 0.1);

          h5 {
            height: 36px;
            margin-bottom: 20px;
            font-size: 24px;
            line-height: 36px;
          }

          img {
            width: 790px;
            height: 52px;
            margin-bottom: 8px;
          }

          &-list:not(:last-child) {
            margin-right: 32px;
            color: #2d2d2d;
          }
        }
      }
    }
  }

  .unspecial-container {
    background-color: rgba(255, 255, 255, 0.85);
    box-shadow: 0 0 60px 0 rgba(17, 128, 255, 0.1);

    &:before {
      background: linear-gradient(243deg, rgba(45, 45, 45, 0) 0%, rgba(45, 45, 45, 0.06) 53%, rgba(45, 45, 45, 0) 100%);
    }

    &:after {
      background: linear-gradient(243deg, rgba(45, 45, 45, 0) 0%, rgba(45, 45, 45, 0.08) 53%, rgba(45, 45, 45, 0) 100%);
    }
  }
}
</style>
